import React from 'react';
const WashingMachineIcon = () => (
    <svg width="28" height="32" viewBox="0 0 93 106" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="1.5"
            y="1"
            width="90"
            height="104"
            rx="5"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <circle cx="46.5" cy="62" r="32" fill="white" stroke="black" strokeWidth="2" />
        <path
            d="M26 75.5672C28.5 75.5672 29.9 74.5672 31.5 72.5672C33.5 70.0672 34 66.0672 38.5 66.0672C44 66.0672 44.5 75.5672 50.5 75.5672C57 75.5672 58 65 64 65C68 65 68 68.5672 70.5 68.5672"
            stroke="#32AE57"
            strokeWidth="2"
        />
        <circle cx="46.5" cy="62" r="25" stroke="black" strokeWidth="2" />
        <rect x="0.5" y="22" width="92" height="2" fill="black" />
        <rect
            x="7.5"
            y="7"
            width="20"
            height="10"
            rx="2"
            fill="white"
            stroke="black"
            strokeWidth="2"
        />
        <circle cx="54.5" cy="12" r="5" fill="white" stroke="black" strokeWidth="2" />
        <mask id="path-8-inside-1_1079_12867" fill="white">
            <rect x="72" y="9" width="6" height="6" rx="1" />
        </mask>
        <rect
            x="72"
            y="9"
            width="6"
            height="6"
            rx="1"
            fill="white"
            stroke="black"
            strokeWidth="4"
            mask="url(#path-8-inside-1_1079_12867)"
        />
        <mask id="path-9-inside-2_1079_12867" fill="white">
            <rect x="80" y="9" width="6" height="6" rx="1" />
        </mask>
        <rect
            x="80"
            y="9"
            width="6"
            height="6"
            rx="1"
            fill="white"
            stroke="black"
            strokeWidth="4"
            mask="url(#path-9-inside-2_1079_12867)"
        />
    </svg>
);

export default WashingMachineIcon;
